export default function MediaSection() {
  const mediaItems = [
    { id: 1, title: "独家实拍：某顶流深夜约会神秘女子全过程", duration: "08:32", views: "326万", imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20night%20scene%20with%20deep%20crimson%20and%20dark%20tones%2C%20video%20player%20interface%20mockup%20style%2C%20dramatic%20lighting%2C%20modern%20media%20thumbnail%20aesthetic%2C%20professional%20video%20cover%20design&width=800&height=450&seq=media-v01&orientation=landscape" },
    { id: 2, title: "知情人录音曝光：选秀节目黑幕交易细节", duration: "15:47", views: "258万", imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20video%20thumbnail%20with%20warm%20amber%20and%20burgundy%2C%20audio%20waveform%20visualization%20style%2C%20modern%20media%20player%20aesthetic%2C%20dramatic%20contrast%2C%20professional%20design&width=800&height=450&seq=media-v02&orientation=landscape" },
    { id: 3, title: "现场直击：综艺录制冲突完整录像", duration: "06:15", views: "197万", imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20scene%20with%20dark%20red%20and%20charcoal%20palette%2C%20studio%20set%20atmosphere%20style%2C%20video%20thumbnail%20mockup%2C%20modern%20media%20aesthetic%2C%20professional%20cover%20design&width=800&height=450&seq=media-v03&orientation=landscape" },
    { id: 4, title: "深度调查：娱乐圈灰色产业链揭秘", duration: "22:08", views: "164万", imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20investigative%20journalism%20thumbnail%20with%20deep%20burgundy%20and%20dark%20gray%2C%20documentary%20style%20visual%2C%20video%20player%20mockup%2C%20modern%20media%20design%2C%20professional%20aesthetic&width=800&height=450&seq=media-v04&orientation=landscape" },
  ];

  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 gap-3">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-vidicon-line text-xl text-primary-600"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                黑料视频
              </h2>
            </div>
            <p className="text-sm text-foreground-500">精选热门爆料视频，高清在线播放</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 via-transparent to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-xl md:text-2xl text-background-50 ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[11px] font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-2 whitespace-nowrap">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次播放
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}